<template>
    <div class="projects">
        <h3>Projects</h3>
        <hr>
        <div v-for="prj in projects" :key="prj.id" class="list-complete-item">
            <a>
                <b-img :src="require('@/assets/pictures/' + prj.picture)" fluid-grow alt="picture"></b-img>
                <div class="overlay">
                    <div class="overlay-content">
                        <div class="overlay-content-title">
                            {{ prj.title }}
                        </div>
                        <div class="overlay-content-type">
                            Type: {{prj.type}}
                        </div>
                        <div v-html="prj.description" class="overlay-content-paragraph"></div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Projects',
    data() {
        return {
            projects: [
                {
                    id: 1,
                    title: "Sorting Algorithm Visualizer",
                    type: "Personal",
                    description: "<div>Created a visual representation of multiple sorting algorithms using the QT framework for C++</div> \
                        <div>The sorting component was handled using multithreading to ensure a fluid GUI with minimum lag</div> \
                        <div>Gained insight into how different sorting algorithms like Quick, Merge and Bucket- Sort can be applied in different situations</div>",
                    picture: "sort.png"
                },
                {
                    id: 2,
                    title: "The Pedi-Electric Sole",
                    type: "School Project",
                    description: "<div>Invented a sole/sock hybrid that registered pressure points when walking</div> \
                        <div>Implemented software using C/C++ that would register potential swelling in the foot and alert the user, as well as \
                        plotted data points using Matlab for later displaying and analysis</div> \
                        <div>Implemented a datastore to store data points for later use and analysis</div>",
                    picture: "sole1.png"
                },
                {
                    id: 3,
                    title: "Linux Terminal Simulation",
                    type: "School Project",
                    description: "<div>Simulated a simplified Linux terminal using Java for Windows to gain better insight into parsing, syntax, coding standards and file management</div> \
                        <div>Commands like “ls” (list) and “cd” (change directory) would be parsed, executed and cached for potential reuse</div>",
                    picture: "terminal.png"
                },
                {
                    id: 4,
                    title: "Autonomous Obstacle Avoiding Vehicle",
                    type: "School Project",
                    description: "<div>Created a vehicle that when given a path avoids obstacles while still getting from A to B, as well as being able to traverse a labyrinth using the shortest route based on multiple pathing algorithms</div> \
                        <div>Programmed the pathing algorithms (dijkstra's, A*) and the I/O communication between hardware components using C</div>",
                    picture: "autocar.png"
                },
                {
                    id: 5,
                    title: "Homemade Computer",
                    type: "Personal",
                    description: "<div>Mimicking a 6502 CPU architecture and specification to create a “homemade” computer using a combination of \
                        logic gates and other low level circuitry</div> \
                        <div>Created a custom assembler using C to feed instructions to the computer</div> \
                        <div>The long term goal is to create a \"turing complete\" computer with its own kernel, operating system etc. All made from scratch</div>",
                    picture: "computer.png"
                },
                {
                    id: 6,
                    title: "henrikdavidsen.com",
                    type: "Personal",
                    description: "<div>This website was created using the Vue JavaScript framework, along with Bootstrap for HTML and CSS styling</div> \
                        <div>This is a Single Page Application website featuring lazy loading, which ensures faster initial load times and better memory usage</div>  \
                        <div>The website is hosted using Google's App Engine, with a Go runtime serving as the API and backend</div>",
                    picture: "website1.png"
                },
            ]
        }
    }
}
</script>

<style scoped>
.projects {
    background: white;
    border-radius: 10px;
}

.list-complete-item {
    width: 40%;
    height: 100%;
    display: inline-block;
    margin: 20px;
}
.list-complete-item a {
    display: inline-block;
    position: relative;
    width: 100%;
    height: 100%;
}

.overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
    background-color: black;
}

.list-complete-item a:hover .overlay {
    opacity: 0.85;
}
 .overlay-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
}

.overlay-content-title {
    padding: 5px;
    color: white;
    font-size: 20px;
    font-weight: bold;
    font-family: Georgia, 'Times New Roman', Times, serif;
    text-transform: uppercase;
}

.overlay-content-type {
    color: rgb(230, 230, 230);
    font-size: 17px;
    padding-bottom: 5px;
}

.overlay-content-paragraph {
    color: lightgray;
    padding: 0 5px 0 15px;
    font-size: 11pt;
    text-align: left;
}

.overlay-content-paragraph >>> * {
    margin-bottom: 10px;
}
</style>